<template lang="pug">
div
    BreadCrumb(:linkBreadCrumb="linkBreadCrumb")
    //CrudForm(
        v-bind="staticData"
        :fields="myFields"
            :customRules="customRules"
            @submitForm="handleSubmit($event)"
            :noButtons="!$can('CREATE_PRODUCT_FAMILY')"
        )
    model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="crear comisión"
        :fields="fields"
        v-model="formData"
        @reset="resetForm"
        @submit="handleSubmit"
        )
</template>

<script>
//-
import { ModelForm } from '@/components/reusable_components/next'
import { BreadCrumb } from '@/components/reusable_components'
import CommuneService from '@/services/api/commune/CommuneService'
import FamilyService from '@/services/api/family/FamilyServices'
//-
import MdlFamily from '../../models/Warehouse/WhFamily'
import FieldsCreate from './FieldsCreate'
//-
import { mapActions } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            formData: {},
            form: null,
            fields: FieldsCreate,
            // customRules: {
            //     minLength8: function(value) {
            //         return value.length >= 8 ? true : 'El largo mínimo es 8'
            //     },
            // },
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: false,
                    to: `/families`,
                    exact: true,
                },
                {
                    text: 'Nueva Familia',
                    disabled: true,
                },
            ],
        }
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        handleSubmit: async function(data) {
            new MdlFamily(data)
                .save()
                .then(this.handleResponse)
                .catch(this.showErrorSnackbar)
        },
        resetForm() {
            this.formData = {}
        },
        handleResponse(response) {
            //
            if (response.status === 'success')
                return this.showSuccessSnackbar(
                    this.$router.push({ path: '/families' })
                )
            //
            return this.showErrorSnackbar(response)
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response.error, false, 3000)
            )
        },
        showSuccessSnackbar() {
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Familia creada exitosamente.',
                    false,
                    3000
                )
            )
        },
        // fillStaticFormData() {
        //     let information = {}
        //     information.toolbarTitle = 'Nueva Familia'
        //     information.toolbarIcon = 'close'
        //     information.customRules = function(value) {
        //         return value.length >= 8 ? true : 'El largo mínimo es 8'
        //     }
        //     information.editable = false
        //     information.disabled = false
        //     information.submitText = 'Crear Familia'

        //     return information
        // },
    },
    watch: {},
    components: { 'model-form': ModelForm, BreadCrumb },
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeMount: async function() {
        this.setTitleTopBar('Nueva Familia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PRODUCT_FAMILY')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
